import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { scrollToElement } from '../utils/scrollToElement';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-cream/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-74">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-75">
        <div className="font-serif text-2xl tracking-wide text-ink" data-id="element-76">
          El Cambio Hormonal
        </div>
        <Button onClick={() => scrollToElement('precio')} className="hidden md:inline-flex px-6 py-3 text-xs" data-id="element-77">
          Comenzar
        </Button>
      </div>
    </header>;
}